//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import startCase from 'lodash/startCase'

import colors from 'components/utils/colors'

const StyledBody = styled.div`
`

const InfoLine = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 18px;
  height: 32px;
  color: ${colors.contentSecondaryActive};
  padding: 0 16px 4px 16px;
`

const TabSection = styled.div`
  background: ${colors.secondary95};
  padding: 4px 12px 0 12px;
`

const TabSectionHeader = styled.div`
  color: #000;
  font-family: Exo;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  padding: 0;
`

const TabSectionBody = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${colors.secondary20};
`

const ConfirmDialogBody = ({ additionalProps }) => {
  const { t } = useTranslation()

  const infoLine = t('common.justificationInfoLine')

  const additionalInfoLine = additionalProps.values.map(value => startCase(value)).join(', ').toUpperCase()

  return (
    <StyledBody>
      <InfoLine data-test='confirm-info-line'>{infoLine}</InfoLine>
      <TabSection>
        <TabSectionHeader>{t('ticketEditPage.fields')}</TabSectionHeader>
        <TabSectionBody>{additionalInfoLine}</TabSectionBody>
      </TabSection>
    </StyledBody>
  )
}

ConfirmDialogBody.propTypes = {
  additionalProps: PropTypes.object.isRequired,
}

export default ConfirmDialogBody
